import { render, staticRenderFns } from "./MultiSelectboxArray.vue?vue&type=template&id=71879e6e&"
import script from "./MultiSelectboxArray.vue?vue&type=script&lang=js&"
export * from "./MultiSelectboxArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports